import React, {
  useEffect,
  useState
} from "react";

import {
  Link,
  useNavigate
} from "react-router-dom";

import {
  FaEye,
  FaMoneyBillWave,
  FaEdit,
  FaTrash,
  FaWallet
} from "react-icons/fa";

import API from "../../services/api";
import { hasPermission } from "../../utils/permission";
import DirectDueModal from "./DirectDueModal";

function Customers() {

  const navigate =
    useNavigate();

  const [customers,
    setCustomers] =
    useState([]);

  const [page,
    setPage] =
    useState(1);

  const [pages,
    setPages] =
    useState(1);

  const [search,
    setSearch] =
    useState("");

  const [showDueModal,
    setShowDueModal] =
    useState(false);

  const [selectedCustomer,
    setSelectedCustomer] =
    useState(null);

  useEffect(() => {
    loadCustomers();
  }, [page, search]);

  const loadCustomers =
    async () => {

      try {

        const token =
          localStorage.getItem(
            "adminToken"
          );

        const res =
          await API.get(
            `/customers?page=${page}&search=${search}`,
            {
              headers: {
                Authorization:
                  `Bearer ${token}`
              }
            }
          );

        setCustomers(
          res.data.customers || []
        );

        setPages(
          res.data.pages || 1
        );

      } catch (err) {
        console.log(err);
      }

    };

  const deleteCustomer =
    async (id) => {

      if (
        !window.confirm(
          "Delete Customer?"
        )
      ) return;

      try {

        const token =
          localStorage.getItem(
            "adminToken"
          );

        await API.delete(
          `/customers/${id}`,
          {
            headers: {
              Authorization:
                `Bearer ${token}`
            }
          }
        );

        loadCustomers();

      } catch (err) {
        console.log(err);
      }

    };

  const openDueModal = (customer) => {

    setSelectedCustomer(customer);

    setShowDueModal(true);

  };

  return (
    <div>

      {/* HEADER */}

      <div
        className="
        flex
        flex-col
        md:flex-row
        md:items-center
        md:justify-between
        gap-4
        mb-6
        "
      >

        <h1
          className="
          text-3xl
          md:text-4xl
          font-bold
          "
        >
          Customers
        </h1>

        {hasPermission("customer.add") && (
          <Link
            to="/admin/customers/add"
            className="
          bg-yellow-500
          text-black
          px-5
          py-3
          rounded-xl
          font-semibold
          text-center
          "
          >
            Add Customer
          </Link>
        )}

      </div>

      {/* SEARCH */}

      <input
        value={search}
        onChange={(e) =>
          setSearch(
            e.target.value
          )
        }
        placeholder="Search Customer..."
        className="
        w-full
        md:w-96
        p-3
        rounded-xl
        bg-[#111]
        border
        border-yellow-500/20
        mb-6
        "
      />

      {/* MOBILE */}

      <div className="md:hidden space-y-4">

        {customers.map((item) => (

          <div
            key={item.id}
            className="
            bg-[#111]
            rounded-2xl
            p-4
            border
            border-yellow-500/10
            "
          >

            <div className="flex justify-between">
              <span>Name</span>
              <span>{item.customer_name}</span>
            </div>

            <div className="flex justify-between mt-2">
              <span>Phone</span>
              <span>{item.phone}</span>
            </div>

            <div className="flex justify-between mt-2">
              <span>Email</span>
              <span>{item.email}</span>
            </div>

            <div className="flex justify-between mt-2">
              <span>GST</span>
              <span>{item.gst_no}</span>
            </div>

            <div className="flex justify-between mt-2">
              <span>Invoice Due</span>

              <span className="font-semibold text-red-400">
                ₹
                {Number(
                  item.total_invoice_due || 0
                ).toFixed(2)}
              </span>
            </div>

            <div className="flex justify-between items-center mt-2">

              <span>Direct Due</span>

              <div className="flex items-center gap-2">

                <span className="font-semibold text-orange-400">
                  ₹
                  {Number(item.direct_due || 0).toFixed(2)}
                </span>

              </div>

            </div>

            <div className="flex justify-between mt-2">
              <span>Total Due</span>

              <span className="font-bold text-yellow-400">
                ₹
                {(
                  Number(item.total_invoice_due || 0) +
                  Number(item.direct_due || 0)
                ).toFixed(2)}
              </span>
            </div>

            <div className="flex justify-between mt-2">

              <span>Status</span>

              <span
                className={
                  Number(item.status) === 1
                    ? "text-green-500"
                    : "text-red-500"
                }
              >
                {Number(item.status) === 1
                  ? "Active"
                  : "Inactive"}
              </span>

            </div>

            <div className="grid grid-cols-2 gap-2 mt-5">

              <button
                onClick={() =>
                  navigate(
                    `/admin/customers/${item.id}`
                  )
                }
                className="
                    flex
                    items-center
                    justify-center
                    gap-2
                    bg-indigo-600
                    py-2
                    rounded-lg
                    "
              >
                <FaEye />

                Profile
              </button>

              {
                hasPermission("customer.edit") && (

                  <button
                    onClick={() =>
                      openDueModal(item)
                    }
                    className="
                            flex
                            items-center
                            justify-center
                            gap-2
                            bg-green-600
                            py-2
                            rounded-lg
                            "
                  >
                    <FaWallet />

                    Direct Due
                  </button>

                )
              }

              {
                hasPermission("customer.edit") && (

                  <button
                    onClick={() =>
                      navigate(
                        `/admin/customers/edit/${item.id}`
                      )
                    }
                    className="
                            bg-blue-500
                            py-2
                            rounded-lg
                            "
                  >
                    Edit
                  </button>

                )
              }

              {
                hasPermission("customer.delete") && (

                  <button
                    onClick={() =>
                      deleteCustomer(item.id)
                    }
                    className="
                            bg-red-500
                            py-2
                            rounded-lg
                            "
                  >
                    Delete
                  </button>

                )
              }

            </div>

          </div>

        ))}

      </div>

      {/* DESKTOP */}

      <div
        className="
        hidden
        md:block
        bg-[#111]
        rounded-2xl
        overflow-hidden
        "
      >

        <div className="overflow-x-auto">

          <table className="w-full">

            <thead className="
                border-b
                border-yellow-500/20
                ">

              <tr>

                <th className="p-3 text-left">Customer</th>

                <th className="p-3 text-left">Phone</th>

                <th className="p-3 text-left">Email</th>

                <th className="p-3 text-left">GST</th>

                <th className="p-3 text-center">
                  Invoice Due
                </th>

                <th className="p-3 text-center">
                  Direct Due
                </th>

                <th className="p-3 text-center">
                  Total Due
                </th>

                <th className="p-3 text-center">
                  Status
                </th>

                <th className="p-3 text-center">
                  Actions
                </th>

              </tr>

            </thead>

            <tbody>

              {customers.map((item) => (

                <tr
                  key={item.id}
                  className="
            border-b
            border-white/10
            hover:bg-white/5
            "
                >

                  <td className="p-3">
                    {item.customer_name}
                  </td>

                  <td className="p-3">
                    {item.phone}
                  </td>

                  <td className="p-3">
                    {item.email}
                  </td>

                  <td className="p-3">
                    {item.gst_no}
                  </td>

                  <td className="p-3 text-center">

                    <div className="flex items-center justify-center gap-2">

                      <span className="text-red-400 font-semibold">

                        ₹
                        {Number(
                          item.total_invoice_due || 0
                        ).toFixed(2)}

                      </span>

                    </div>

                  </td>

                  <td className="p-3 text-center">

                    <div className="flex items-center justify-center gap-2">

                      <span className="text-orange-400 font-semibold">
                        ₹
                        {Number(item.direct_due || 0).toFixed(2)}
                      </span>

                      <button
                        onClick={() => openDueModal(item)}
                        title="Update Direct Due"
                        className="
            text-yellow-400
            hover:text-yellow-300
            transition
            "
                      >
                        <FaWallet />
                      </button>

                    </div>

                  </td>

                  <td className="p-3 text-center">

                    <span className="font-bold text-green-400">

                      ₹
                      {(
                        Number(item.total_invoice_due || 0) +
                        Number(item.direct_due || 0)
                      ).toFixed(2)}

                    </span>

                  </td>

                  <td className="p-3 text-center">

                    <span
                      className={
                        Number(item.status) === 1
                          ? "text-green-500"
                          : "text-red-500"
                      }
                    >
                      {Number(item.status) === 1
                        ? "Active"
                        : "Inactive"}
                    </span>

                  </td>

                  <td className="p-3">

                    <div className="flex justify-center gap-2 flex-wrap">

                      <button
                        onClick={() =>
                          navigate(
                            `/admin/customers/${item.id}`
                          )
                        }
                        className="
                        px-3
                        py-2
                        rounded-lg
                        bg-indigo-600
                        hover:bg-indigo-700
                        text-white
                        "
                      >
                        <FaEye />
                      </button>

                      {
                        hasPermission("customer.edit") && (

                          <button
                            onClick={() =>
                              navigate(
                                `/admin/customers/edit/${item.id}`
                              )
                            }
                            className="
                                px-3
                                py-2
                                rounded-lg
                                bg-blue-600
                                hover:bg-blue-700
                                text-white
                                "
                          >
                            <FaEdit />
                          </button>

                        )
                      }

                      {
                        hasPermission("customer.delete") && (

                          <button
                            onClick={() =>
                              deleteCustomer(item.id)
                            }
                            className="
                                px-3
                                py-2
                                rounded-lg
                                bg-red-600
                                hover:bg-red-700
                                text-white
                                "
                          >
                            <FaTrash />
                          </button>

                        )
                      }

                    </div>

                  </td>

                </tr>

              ))}

            </tbody>

          </table>

        </div>

      </div>

      {/* PAGINATION */}

      <div className="flex items-center gap-2 mt-6 flex-wrap">

        <button
          disabled={page === 1}
          onClick={() =>
            setPage(page - 1)
          }
          className="
          px-4 py-2 rounded-lg bg-[#111]
          "
        >
          Back
        </button>

        {[...Array(pages)].map(
          (_, i) => (

            <button
              key={i}
              onClick={() =>
                setPage(i + 1)
              }
              className={`
                px-4 py-2 rounded-lg
                ${page === i + 1
                  ? "bg-yellow-500 text-black"
                  : "bg-[#111]"
                }
              `}
            >
              {i + 1}
            </button>

          )
        )}

        <button
          disabled={page === pages}
          onClick={() =>
            setPage(page + 1)
          }
          className="
          px-4 py-2 rounded-lg bg-[#111]
          "
        >
          Next
        </button>

      </div>

      {
        showDueModal &&
        selectedCustomer && (

          <DirectDueModal
            open={showDueModal}
            customer={selectedCustomer}
            onClose={() =>
              setShowDueModal(false)
            }
            onSuccess={loadCustomers}
          />

        )
      }

    </div>
  );
}

export default Customers;